import { isIpfError } from '@ipfabric/frontend-shared-assets/utils/IpfError';
import type { GlobalStateCommandFactory } from 'components/GlobalState/GlobalStateModel';
import { authenticate } from './authenticate';
import { type AuthResponseData, saveAuth } from './saveAuth';

interface LoginCommand {
  password: string;
  username: string;
}

interface LoginSSOCommand {
  accessToken: string;
}

const commandIsLoginSSOCommand = (
  command: LoginCommand | LoginSSOCommand,
): command is LoginSSOCommand => 'accessToken' in command;

export const login: GlobalStateCommandFactory<LoginCommand | LoginSSOCommand> =
  (cmdContext, dispatch) => async (command) => {
    try {
      const responseData = commandIsLoginSSOCommand(command)
        ? await cmdContext.api.request<AuthResponseData>({
            url: '/auth/token/swap',
            method: 'POST',
            options: {
              headers: {
                Authorization: `Bearer ${command.accessToken}`,
              },
            },
          })
        : await cmdContext.api.request<AuthResponseData>({
            url: '/auth/login',
            method: 'POST',
            data: command,
          });
      dispatch(saveAuth, responseData);

      const { state } = cmdContext.getState().location;
      await dispatch(authenticate);
      const hasSettingsPermissions = cmdContext
        .getState()
        .auth.scope.includes('settings');
      const selectedSnapshot = cmdContext.reduxStore
        .getState()
        .getIn(['snapshotManagement', 'selectedSnapshot']);
      if (!selectedSnapshot && hasSettingsPermissions) {
        cmdContext.navigate('/wizard/1');
      } else {
        cmdContext.navigate(
          state?.nextPathName !== undefined &&
            state.nextPathName !== '/login' &&
            state.nextPathName !== '/upload-license'
            ? state.nextPathName
            : '/',
        );
      }
    } catch (e) {
      if (isIpfError(e) && e.type === 'INVALID_CREDENTIALS') {
        cmdContext.showNotification({ type: 'danger', message: e.message });
      } else {
        throw e;
      }
    }
  };
